import { useNavigate } from "react-router-dom";
import { IconButton, Menu, MenuItem, Toolbar, Typography, Tooltip } from "@mui/material";
import { useImmer } from "use-immer";
import { AppBar } from "./Style";
import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
// import logo from "../../Images/bitcommLogo.png";

// import logo from "../../Images/bitcommLogo.png";
import ProfileModal from "../../Modal/ProfileModal";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import "./Header.scss";
import { useDispatch, useSelector } from "react-redux";
import LiveStatusClock from "./LiveStatusClock/LiveStatusClock";
import { logoutSuccess, permittedCustomersSelector } from "../../features/authentication/auth-slice";
import Box from "@mui/material/Box";
import { StationsSelect } from "./components/StationsSelect";
import AlarmNotificationSound from "./components/AlarmNotificationSound";
import AlarmsNotifications from "./components/AlarmsNotifications";
import useFirebaseCloudMessaging from "../../hooks/fcm/useFirebaseCloudMessaging";
import LogoutPopup from "./components/LogoutPop/LogoutPopup";
import { Avatar } from "antd";
import NewStationSelector from "./components/NewStationSelector";

const initialState = {
  auth: true,
  openUserMenu: false,
  label: "",
  menuOpen: false,
  showProfileModal: false,
  stations: [],
  updatedUserData: null,
};

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const permittedCustomers = useSelector(permittedCustomersSelector) ?? [];
  const [state, setState] = useImmer({ ...initialState, stations: permittedCustomers });
  const header_label = useMemo(() => {
    const head = (endHeader, name) => {
      if (endHeader !== undefined && name !== undefined) {
        return name;
      } else {
        return "";
      }
    };
    const startingHeader = location?.pathname?.substring(1)?.replace("-", " ")?.split("/")[0]?.toUpperCase();
    const endHeader = location?.pathname?.split("_")[1];
    const name = location?.pathname?.split("_")[2];
    const _newHeaderLabel = startingHeader + head(endHeader, name);

    const newHeaderLabel = decodeURIComponent(_newHeaderLabel);
    return newHeaderLabel;
  }, [location]);
  const [anchorProfileMenu, setAnchorProfileMenu] = useState(null);
  const [logoutPop, setLogoutPop] = useImmer(false);
  const dispatch = useDispatch();

  const { unregisterUser } = useFirebaseCloudMessaging();

  let USER_NAME = localStorage.getItem("user") ?? "";
  let USER_EMAIL = localStorage.getItem("email");
  USER_NAME = USER_NAME.slice(0, 2).toUpperCase();

  // useEffect(() => {
  //   const head = (endHeader, name) => {
  //     if (endHeader !== undefined && name !== undefined) {
  //       return " " + name;
  //     } else {
  //       return " ";
  //     }
  //   };
  //   const startingHeader = location?.pathname?.substring(1)?.replace("-", " ")?.split("/")[0]?.toUpperCase();
  //   const endHeader = location?.pathname?.split("_")[1];
  //   const name = location?.pathname?.split("_")[2];
  //   const _newHeaderLabel = startingHeader + head(endHeader, name);

  //   const newHeaderLabel = decodeURIComponent(_newHeaderLabel);
  //   setState((draft) => {
  //     draft.headerLabel = newHeaderLabel;
  //   });
  // }, [location]);

  /**
   * open the dropdown menu next to stations dropdown to allow for user profile options
   */
  const handleMenu = (e) => {
    setAnchorProfileMenu(e.currentTarget);
    setState((draft) => {
      draft.openUserMenu = !state.openUserMenu;
    });
  };

  /**
   * close the user profile options dropdown
   */
  const handleClose = () => {
    setState((draft) => {
      draft.openUserMenu = !state.openUserMenu;
    });
  };

  async function handleLogout() {
    setLogoutPop(true);
    // const unregister = await unregisterUser();

    // dispatch(logoutSuccess());
  }

  /**
   * for opening the profile popup with user details
   */
  const handleOpenProfile = () => {
    setState((draft) => {
      draft.showProfileModal = true;
      draft.openUserMenu = false;
    });
  };

  /**
   * to close the profile popup inside user details dropdown
   */
  const handleCloseProfile = () => {
    setState((draft) => {
      draft.showProfileModal = false;
    });
  };

  const backBtn = () => {
    window.history.back();
  };
  console.log("header_label", header_label, header_label.length);
  return (
    <div className="site-header">
      <div className="upper-header">
        <div className="header-left">
          <div className="app-name">
            Telecom Asset Management System {`${header_label?.length ? " - " + header_label : ""}`}
          </div>
          {/* <div className="route-label">{header_label}</div> */}
        </div>
        <div className="header-right">
          <LiveStatusClock />
          <AlarmNotificationSound />
          <AlarmsNotifications />
          {/* <StationsSelect /> */}
          <NewStationSelector />
          <Tooltip placement="bottom" title={USER_EMAIL ?? "Profile"} disableInteractive>
            <Avatar
              onClick={(e) => handleMenu(e)}
              className="porfile-avtar"
              sizes="small"
              alt="Remy Sharp"
              src="/broken-image.jpg"
            >
              {USER_NAME}
            </Avatar>
            {/* <IconButton
  
              aria-label="account of current user"
              // aria-controls="menu-appbar"
              size={"small"}
              // aria-haspopup="true"
              onClick={(e) => handleMenu(e)}
            >
              <div className="avatar cursor-pointer">{USER_NAME}</div>
            </IconButton> */}
          </Tooltip>
          <Menu id="menu-appbar" anchorEl={anchorProfileMenu} open={Boolean(state.openUserMenu)} onClose={handleClose}>
            <MenuItem onClick={handleOpenProfile}>Profile</MenuItem>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
          {state.showProfileModal && <ProfileModal open={state.showProfileModal} onClose={handleCloseProfile} />}
          {logoutPop && <LogoutPopup open={logoutPop} onClose={() => setLogoutPop(false)} />}
        </div>
      </div>
      <div className="lower-header"></div>
    </div>
    // <AppBar size="small" className="site-header" position="fixed" open>
    //   <Toolbar className="header-toolbar">
    //     <img
    //       className="pointer"
    //       onClick={() => {
    //         navigate("/");
    //       }}
    //       src={logo}
    //       alt="Bitcomm Logo"
    //       height="50px"
    //     />

    //     {!["", "home", "dashboard"].includes(location.pathname.split("/")[1]) && (
    //       <>
    //         <div className="header-back-button">
    //           <IconButton color="inherit" onClick={backBtn}>
    //             <ArrowBackIosNewIcon fontSize="small" />
    //           </IconButton>
    //         </div>
    //         <Typography noWrap component="div">
    //           {state.headerLabel}
    //         </Typography>
    //       </>
    //     )}

    //     {state.auth && (
    //       <Box className="flex alignCenter absolute right">
    //         <LiveStatusClock />
    //         <AlarmNotificationSound />
    //         <AlarmsNotifications />
    //         <StationsSelect />

    //         <Tooltip placement="bottom" title={"Profile"} disableInteractive>
    //           <IconButton
    //             size="small"
    //             aria-label="account of current user"
    //             aria-controls="menu-appbar"
    //             aria-haspopup="true"
    //             onClick={(e) => handleMenu(e)}
    //             // color="primary"
    //             // color="inherit"
    //           >
    //             <div className="avatar cursor-pointer">{USER_NAME}</div>
    //           </IconButton>
    //         </Tooltip>
    //         <Menu
    //           id="menu-appbar"
    //           anchorEl={anchorProfileMenu}
    //           open={Boolean(state.openUserMenu)}
    //           onClose={handleClose}
    //         >
    //           <MenuItem onClick={handleOpenProfile}>Profile</MenuItem>
    //           <MenuItem onClick={handleLogout}>Logout</MenuItem>
    //         </Menu>
    //         {state.showProfileModal && <ProfileModal open={state.showProfileModal} onClose={handleCloseProfile} />}
    //         {logoutPop && <LogoutPopup open={logoutPop} onClose={() => setLogoutPop(false)} />}
    //       </Box>
    //     )}
    //   </Toolbar>
    // </AppBar>
  );
};
export default Header;
